import React from "react";
import "./Project.scss";
import extremeheat from "../../assets/images/extemeheat.png";
import extremerainfall from "../../assets/images/extremerainfall.png";
import sealevelrise from "../../assets/images/sealevelrise.png";
import emissionreduction from "../../assets/images/emissionreduction.png";
import sustainablepractices from "../../assets/images/sustainablepractices.png";
import carboncredits from "../../assets/images/carboncredits.png";
import sdgsaddressed from "../../assets/images/sdgsaddressed.png";
import womenbeneficiaries from "../../assets/images/womenbeneficiaries.png";
import womenchangemakers from "../../assets/images/womenchangemakers.png";
const benefitImages = {
  extremeRainfall: extremerainfall,
  extremeHeat: extremeheat,
  seaLevelRise: sealevelrise,
};
const coBenefitImages = {
  "Emission Reduction": emissionreduction,
  "Sustainable Practices": sustainablepractices,
  "Carbon Credits": carboncredits,
  "SDGs Addressed": sdgsaddressed,
  "Women as Beneficiaries": womenbeneficiaries,
  "Women as Changemakers": womenchangemakers,
};
const ProjectCard = ({ project }) => {
  return (
    <div className="project-card">
      <div className="card-header">
        <h2 className="card-title">{project?.title}</h2>
        <div className="icon-gap">
          {project?.benefits?.map((benefit) => (
            <img
              key={benefit}
              src={benefitImages[benefit]}
              alt={benefit}
              className="benefit-icon"
            />
          ))}
        </div>
      </div>

      <p className="card-description">{project?.description}</p>

      <div className="details">
        <div className="stats">
          <p className="stat">
            <span className="highlight green">{project?.beneficiaries}</span>{" "}
            Direct beneficiaries
          </p>
          <p className="stat">
            <span className="highlight green">{project?.impact}</span> Impact
          </p>
          <p className="stat">
            <span className="highlight red">{project?.cost}</span> Capital Cost
          </p>
        </div>
        <div className="benefits-1">
          <h4>CO BENEFITS</h4>
          <div className="icons">
            {project?.coBenefits?.map((coBenefit, index) => (
              <img
                key={index}
                src={coBenefitImages[coBenefit]}
                alt={coBenefit}
                className="co-benefit-icon"
              />
            ))}
          </div>
        </div>
      </div>
      <div className="learn-more">
        {project?.pdfPath ? (
          <a href={project.pdfPath} target="_blank" rel="noopener noreferrer">
            LEARN MORE &gt;
          </a>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
